var _a, _b, _c, _d;
import { __assign } from "tslib";
export var SequenceTypes = {
    MAIN_SEQ: 'mainSeq',
    INTERACTIVE_SEQ: 'interactiveSeq',
};
export var PATH_ANIM_TYPES = {
    ARC: 'arc',
    STRAIGHT_LINE: 'straight_line',
    CYCLE: 'cycle',
    SHAPE: 'shape',
    TURN: 'turn',
    CUSTOM: 'custom',
};
export var AnimTypes = __assign(__assign({ NONE: 'none', FADE_IN: 'fade_in', FADE_OUT: 'fade_out', SCALE: 'scale', APPEAR: 'appear', DISAPPEAR: 'disappear', FLY_IN: 'fly_in', FLY_OUT: 'fly_out', FLOAT_UP_IN: 'float_up_in', FLOAT_UP_OUT: 'float_up_out', FLOAT_DOWN_IN: 'float_down_in', FLOAT_DOWN_OUT: 'float_down_out', CUT_IN: 'cut_in', CUT_OUT: 'cut_out', ROTATE: 'rotate', PLUSE: 'pluse', SPREAD: 'spread', ENTR_ROTATE: 'entr_rotate', ENTR_SCALE: 'entr_scale', EXIT_SPREAD: 'exit_spread', EXIT_ROTATE: 'exit_rotate', EXIT_SCALE: 'exit_scale', ENTR_CENTER_REVOLVE: 'entr_center_revolve', ENTR_GROW_TURN: 'entr_grow_turn', ENTR_RISE_UP: 'entr_rise_up', ENTR_SPINNER: 'entr_spinner', ENTR_BASIC_ZOOM: 'entr_basic_zoom', ENTR_STRETCH: 'entr_stretch', EXIT_CENTER_REVOLVE: 'exit_center_revolve', EXIT_SHRINK_TURN: 'exit_shrink_turn', EXIT_SINK_DOWN: 'exit_sink_down', EXIT_SPINNER: 'exit_spinner', EXIT_BASIC_ZOOM: 'exit_basic_zoom', EXIT_STRETCH: 'exit_stretch', EXIT_COLLAPSE: 'exit_collapse', ENTR_BOOMERANG: 'entr_boomerang', ENTR_PINWHEEL: 'entr_pinwheel', ENTR_BASIC_SWIVEL: 'entr_basic_swivel', EXIT_BOOMERANG: 'exit_boomerang', EXIT_PINWHEEL: 'exit_pinwheel', EXIT_BASIC_SWIVEL: 'exit_basic_swivel', EMPH_TRANSPARENCY: 'emph_transparency' }, PATH_ANIM_TYPES), { ENTR_CREDITS: 'entr_credits', EXIT_CREDITS: 'exit_credits', ENTR_BLINDS: 'entr_blinds', EXIT_BLINDS: 'exit_blinds' });
export var NodeType = {
    NONE: 'none',
    CLICK_EFFECT: 'clickEffect',
    WITH_EFFECT: 'withEffect',
    AFTER_EFFECT: 'afterEffect',
};
export var DEFAULT_CLICK_SPID = 'default_click_spid';
export var PRESET_IDS = {
    none: -1,
    appear: 1,
    fade: 10,
    scale: 6,
    fly: 2,
    float: 42,
    floatD: 47,
    rotate: 8,
    pluse: 26,
    cut: 12,
    spread: 55,
    entrRotate: 45,
    entrScale: 53,
    entrCenterRevolve: 43,
    entrGrowTurn: 31,
    entrRiseUp: 37,
    entrSpinner: 49,
    entrBasicZoom: 23,
    entrStretch: 17,
    exitStretch: 50,
    boomerang: 25,
    pinwheel: 35,
    basicSwivel: 19,
    emphTransparency: 9,
    stop: 3,
};
export var SUB_TYPES = {
    none: -1,
    top: 1,
    right: 2,
    topRight: 3,
    bottom: 4,
    bottomRight: 6,
    left: 8,
    topLeft: 9,
    bottomLeft: 12,
    leftRight: 110,
    topBottom: 111,
    total: 112,
    clockwise: 113,
    counterclockwise: 114,
    slideCenter: 528,
    eleCenter: 16,
    toEleCenter: 32,
    toSlideCenter: 544,
    across: 10,
    inSlightly: 272,
    outBottom: 36,
    outSlightly: 288,
    toSlideBottom: 20,
    vertical: 5,
};
export var PRESET_CLASS_TYPES = {
    none: 'none',
    entr: 'entr',
    exit: 'exit',
    emph: 'emph',
    path: 'path',
};
export var STRETCH_TAV_MAP = {
    1: {
        ppt_x: {
            0: '#ppt_x',
            100000: '#ppt_x',
        },
        ppt_y: {
            0: '#ppt_y-#ppt_h/2',
            100000: '#ppt_y',
        },
        ppt_w: {
            0: '#ppt_w',
            100000: '#ppt_w',
        },
        ppt_h: {
            0: 0,
            100000: '#ppt_h',
        },
    },
    4: {
        ppt_x: {
            0: '#ppt_x',
            100000: '#ppt_x',
        },
        ppt_y: {
            0: '#ppt_y+#ppt_h/2',
            100000: '#ppt_y',
        },
        ppt_w: {
            0: '#ppt_w',
            100000: '#ppt_w',
        },
        ppt_h: {
            0: 0,
            100000: '#ppt_h',
        },
    },
    8: {
        ppt_x: {
            0: '#ppt_x-#ppt_w/2',
            100000: '#ppt_x',
        },
        ppt_y: {
            0: '#ppt_y',
            100000: '#ppt_y',
        },
        ppt_w: {
            0: 0,
            100000: '#ppt_w',
        },
        ppt_h: {
            0: '#ppt_h',
            100000: '#ppt_h',
        },
    },
    2: {
        ppt_x: {
            0: '#ppt_x+#ppt_w/2',
            100000: '#ppt_x',
        },
        ppt_y: {
            0: '#ppt_y',
            100000: '#ppt_y',
        },
        ppt_w: {
            0: 0,
            100000: '#ppt_w',
        },
        ppt_h: {
            0: '#ppt_h',
            100000: '#ppt_h',
        },
    },
    10: {
        ppt_w: {
            0: 0,
            100000: '#ppt_w',
        },
        ppt_h: {
            0: '#ppt_h',
            100000: '#ppt_h',
        },
    },
};
export var TN_TYPES = {
    none: 'none',
    tnSet: 'tn_set',
    tnAnimEffect: 'tn_animEffect',
    tnAnimScale: 'tn_animScale',
    tnAnimRot: 'tn_animRot',
    tnAnim: 'tn_anim',
    tnAnimMotion: 'tn_animMotion',
};
export var WH_ATTR_NAME_LIST = ['ppt_w', 'ppt_h'];
export var XY_ATTR_NAME_LIST = ['ppt_x', 'ppt_y'];
export var ENTR_ID_MAP = (_a = {},
    _a[PRESET_IDS.appear] = AnimTypes.APPEAR,
    _a[PRESET_IDS.fade] = AnimTypes.FADE_IN,
    _a[PRESET_IDS.float] = AnimTypes.FLOAT_UP_IN,
    _a[PRESET_IDS.floatD] = AnimTypes.FLOAT_DOWN_IN,
    _a[PRESET_IDS.fly] = AnimTypes.FLY_IN,
    _a[PRESET_IDS.cut] = AnimTypes.CUT_IN,
    _a[PRESET_IDS.spread] = AnimTypes.SPREAD,
    _a[PRESET_IDS.entrRotate] = AnimTypes.ENTR_ROTATE,
    _a[PRESET_IDS.entrScale] = AnimTypes.ENTR_SCALE,
    _a[PRESET_IDS.entrCenterRevolve] = AnimTypes.ENTR_CENTER_REVOLVE,
    _a[PRESET_IDS.entrGrowTurn] = AnimTypes.ENTR_GROW_TURN,
    _a[PRESET_IDS.entrRiseUp] = AnimTypes.ENTR_RISE_UP,
    _a[PRESET_IDS.entrSpinner] = AnimTypes.ENTR_SPINNER,
    _a[PRESET_IDS.entrBasicZoom] = AnimTypes.ENTR_BASIC_ZOOM,
    _a[PRESET_IDS.entrStretch] = AnimTypes.ENTR_STRETCH,
    _a[PRESET_IDS.boomerang] = AnimTypes.ENTR_BOOMERANG,
    _a[PRESET_IDS.pinwheel] = AnimTypes.ENTR_PINWHEEL,
    _a[PRESET_IDS.basicSwivel] = AnimTypes.ENTR_BASIC_SWIVEL,
    _a[PRESET_IDS.stop] = AnimTypes.ENTR_BLINDS,
    _a);
export var EXIT_ID_MAP = (_b = {},
    _b[PRESET_IDS.appear] = AnimTypes.DISAPPEAR,
    _b[PRESET_IDS.fade] = AnimTypes.FADE_OUT,
    _b[PRESET_IDS.fly] = AnimTypes.FLY_OUT,
    _b[PRESET_IDS.float] = AnimTypes.FLOAT_UP_OUT,
    _b[PRESET_IDS.floatD] = AnimTypes.FLOAT_DOWN_OUT,
    _b[PRESET_IDS.cut] = AnimTypes.CUT_OUT,
    _b[PRESET_IDS.spread] = AnimTypes.EXIT_SPREAD,
    _b[PRESET_IDS.entrRotate] = AnimTypes.EXIT_ROTATE,
    _b[PRESET_IDS.entrScale] = AnimTypes.EXIT_SCALE,
    _b[PRESET_IDS.entrCenterRevolve] = AnimTypes.EXIT_CENTER_REVOLVE,
    _b[PRESET_IDS.entrStretch] = AnimTypes.EXIT_COLLAPSE,
    _b[PRESET_IDS.entrGrowTurn] = AnimTypes.EXIT_SHRINK_TURN,
    _b[PRESET_IDS.entrRiseUp] = AnimTypes.EXIT_SINK_DOWN,
    _b[PRESET_IDS.entrSpinner] = AnimTypes.EXIT_SPINNER,
    _b[PRESET_IDS.entrBasicZoom] = AnimTypes.EXIT_BASIC_ZOOM,
    _b[PRESET_IDS.exitStretch] = AnimTypes.EXIT_STRETCH,
    _b[PRESET_IDS.boomerang] = AnimTypes.EXIT_BOOMERANG,
    _b[PRESET_IDS.pinwheel] = AnimTypes.EXIT_PINWHEEL,
    _b[PRESET_IDS.basicSwivel] = AnimTypes.EXIT_BASIC_SWIVEL,
    _b[PRESET_IDS.stop] = AnimTypes.EXIT_BLINDS,
    _b);
export var EMPH_ID_MAP = (_c = {},
    _c[PRESET_IDS.scale] = AnimTypes.SCALE,
    _c[PRESET_IDS.rotate] = AnimTypes.ROTATE,
    _c[PRESET_IDS.pluse] = AnimTypes.PLUSE,
    _c[PRESET_IDS.emphTransparency] = AnimTypes.EMPH_TRANSPARENCY,
    _c);
export var DELAY_RATE_MAP = (_d = {},
    _d[AnimTypes.ENTR_RISE_UP] = 0.9,
    _d[AnimTypes.EXIT_SINK_DOWN] = 0.1,
    _d);
export var ATTR_NAME = {
    rotation: 'style.rotation',
    visibility: 'style.visibility',
    pptX: 'ppt_x',
    pptY: 'ppt_y',
    pptW: 'ppt_w',
    pptH: 'ppt_h',
};
//# sourceMappingURL=time-node-constants.js.map